<template>
  <div class="spinner-loader" :style="{ transform: `scale(${scale})` }">
    <div class="loader" :style="{ '--loader-color': color }"></div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#ffa516',
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner-loader {
  display: inline-block;
}

.loader {
  width: 24px;
  aspect-ratio: 1;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side,var(--loader-color) 94%,#0000) top/4px 4px no-repeat,
    conic-gradient(#0000 30%,var(--loader-color));
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 4px),#000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13{
  100%{transform: rotate(1turn)}
}
</style>
